var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view',{ref:"navbar",attrs:{"name":"navbar","activeTag":_vm.activeTag}}),_vm._v(" "),_c('router-view',{ref:"main"}),_vm._v(" "),_c('router-view',{ref:"info",attrs:{"name":"info"}}),_vm._v(" "),_c('router-view',{ref:"experience",attrs:{"name":"experience"}}),_vm._v(" "),_c('router-view',{ref:"contact",attrs:{"name":"contact"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"footer"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8d46aa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 22
// module chunks = 0